import React, { useState, useEffect, useRef } from "react";
import { ShoppingCart, FlaskConical, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function CartDropdown({ patientId,selectedPatient, onClose,abdmData }) {
      const API_URL = process.env.REACT_APP_API_URL;
    const [cartData, setCartData] = useState({ medicineItems: [], labItems: [] });
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
  const [patientDetails, setPatientDetails] = useState({});
    console.log("CartDropdown - patientId:", patientId); // Debug log

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
const fetchPatientdetails = async () => {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const response = await axios.get(
          `${API_URL}patient/search?patientId=${patientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        console.log(response.data, "zsxdcfvghbjcfvgbh");
        const firstPatient = response?.data.data[0];
        setPatientDetails(firstPatient);
      } catch (error) {
        console.error("Error fetching slots:", error);
      }
    };

useEffect(() => {
    fetchPatientdetails()
      }, [patientId]);

    useEffect(() => {
        const fetchCartData = async () => {
            if (!patientDetails.curebayPatientId) {
                console.log("No patientId available, skipping fetch");
                return;
            }
            
            try {
                console.log("Fetching cart data for patientId:", patientId);
                const response = await fetch(`${process.env.REACT_APP_CARTURL}medicine/details?patientId=${patientDetails.curebayPatientId}`);
                const data = await response.json();
                
                if (data.status === "OK") {
                   
                    setCartData((prev) => ({
  ...prev,
  medicineItems: data?.data?.medicineItems || [],
}));

                }
            } catch (error) {
                console.error('Error fetching cart data:', error);
            }
        };

         const fetchCartData2 = async () => {
            if (!patientDetails.curebayPatientId) {
                console.log("No patientId available, skipping fetch");
                return;
            }
            
            try {
                console.log("Fetching cart data for patientId:", patientId);
                const response = await fetch(`${process.env.REACT_APP_CARTURL}lab/details?patientId=${patientDetails.curebayPatientId}`);
                const data = await response.json();
                // console.log(data?.data?.labTestItems,"data")
                if (data.status === "OK") {
                  
                       setCartData((prev) => ({
  ...prev,
 labItems: data?.data?.labTestItems|| []
}));
                }
            } catch (error) {
                console.error('Error fetching cart data:', error);
            }
        };
        

        fetchCartData();
        fetchCartData2();
    }, [patientDetails]);

    const handleMedicineClick = () => {
        console.log("Navigating to cart page with patientId:", patientId); 
         navigate("/MedicineCartPage", {
      state: {
        patientId: patientId,
        selectedPatient, // you can give it any key name you like
        abdmData
      },
    });
    };
     const handleLabClick = () => {
        console.log("Navigating to cart page with patientId:", patientId); // Debug log
        // navigate("/MedicineCartPage", { state: { patientId } });
         navigate("/LabCartPage", {
      state: {
        patientId: patientId,
        selectedPatient, // you can give it any key name you like
      },
    });
    };


    const totalItems = cartData.medicineItems.length + cartData.labItems.length;
    console.log("Total items in cart:", totalItems); // Debug log

    return (
        <div ref={dropdownRef} className="absolute right-0 top-12 z-50 w-96 origin-top-right animate-slideInFromTop">
            <div className="bg-white shadow-2xl rounded-3xl border border-gray-100 overflow-hidden backdrop-blur-sm transform transition-all duration-300 hover:shadow-3xl">
                {/* Gradient Background Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/30 via-white to-teal-50/20 pointer-events-none"></div>
                
                {/* Header */}
                <div className="relative flex items-center gap-4 px-6 pt-6 pb-4">
                    <div className="relative">
                        <div className="bg-gradient-to-r from-[#00BD7F] to-emerald-500 text-white p-3 rounded-2xl shadow-lg transform hover:rotate-3 transition-transform duration-300">
                            <ShoppingCart className="w-6 h-6" />
                        </div>
                        {totalItems > 0 && (
                            <div className="absolute -top-2 -right-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow-lg animate-pulse">
                                {totalItems}
                            </div>
                        )}
                    </div>
                    <div>
                        <h3 className="text-xl font-bold bg-gradient-to-r from-[#00BD7F] to-emerald-600 bg-clip-text text-transparent">
                            Your Cart
                        </h3>
                        <p className="text-sm text-gray-500 flex items-center gap-1">
                            <Sparkles className="w-3 h-3" />
                            Manage your items
                        </p>
                    </div>
                </div>

                <div className="relative px-6 pb-6 space-y-4">
                    {/* Medicine Section */}
                    <div
                        className="group relative overflow-hidden flex items-center justify-between p-4 bg-gradient-to-r from-[#f5fefb] to-emerald-50/50 rounded-2xl border border-gray-200 hover:border-emerald-200 hover:shadow-lg hover:scale-[1.02] transition-all duration-300 cursor-pointer active:scale-[0.98]"
                        onClick={handleMedicineClick}
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-[#00BD7F]/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <div className="relative flex items-center gap-4">
                            <div className="bg-gradient-to-r from-[#e6f8f0] to-emerald-100 p-3 rounded-2xl group-hover:from-emerald-200 group-hover:to-emerald-100 transition-colors duration-300">
                                <ShoppingCart className="text-[#00BD7F] w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-base font-semibold text-gray-800 group-hover:text-[#00BD7F] transition-colors duration-300">Medicine</p>
                                <p className="text-sm text-gray-500">View medicine items</p>
                            </div>
                        </div>
                        <span className="relative bg-gradient-to-r from-[#00BD7F] to-emerald-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                            {cartData.medicineItems.length}
                        </span>
                    </div>

                    {/* Lab Test Section */}
                    <div className="group relative overflow-hidden flex items-center justify-between p-4 bg-gradient-to-r from-[#f5fefb] to-blue-50/50 rounded-2xl border border-gray-200 hover:border-blue-200 hover:shadow-lg hover:scale-[1.02] transition-all duration-300 active:scale-[0.98]"
                     onClick={handleLabClick}
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-indigo-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <div className="relative flex items-center gap-4">
                            <div className="bg-gradient-to-r from-[#e6f8f0] to-blue-100 p-3 rounded-2xl group-hover:from-blue-200 group-hover:to-blue-100 transition-colors duration-300">
                                <FlaskConical className="text-[#00BD7F] group-hover:text-blue-600 w-5 h-5 transition-colors duration-300" />
                            </div>
                            <div>
                                <p className="text-base font-semibold text-gray-800 group-hover:text-blue-700 transition-colors duration-300">Lab Tests</p>
                                <p className="text-sm text-gray-500">View lab tests </p>
                            </div>
                        </div>
                        <span className="relative bg-gradient-to-r from-[#00BD7F] to-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold shadow-lg group-hover:shadow-xl transition-shadow duration-300">
                            {cartData.labItems.length}
                        </span>
                    </div>

                    <hr className="border-t border-gray-200 my-4" />

                    <div className="bg-gradient-to-r from-gray-50 to-slate-50 rounded-2xl p-4 border border-gray-100">
                        <div className="flex justify-between items-center text-base font-medium text-gray-700">
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-gradient-to-r from-[#00BD7F] to-emerald-500 rounded-full animate-pulse"></div>
                                <span>Total Items</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-900 bg-clip-text text-transparent">
                                    {totalItems}
                                </span>
                                <div className="w-8 h-8 bg-gradient-to-r from-emerald-100 to-[#e6f8f0] rounded-full flex items-center justify-center">
                                    <ShoppingCart className="w-4 h-4 text-[#00BD7F]" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Add custom CSS for animations
const style = document.createElement('style');
style.textContent = `
@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.animate-slideInFromTop {
  animation: slideInFromTop 0.3s ease-out;
}

.shadow-3xl {
  box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.25);
}
`;
document.head.appendChild(style);